var React = require('react');

function ArrowDiagonalBlack (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"11.5","stroke":"black","fill":"none","key":0}),React.createElement("path",{"d":"M16.5512 14.2758V7.4483L9.72363 7.4483","stroke":"black","strokeMiterlimit":"10","fill":"none","key":1}),React.createElement("path",{"d":"M16.6457 7.35383L7.71387 16.2857","stroke":"black","strokeMiterlimit":"10","fill":"none","key":2})]);
}

ArrowDiagonalBlack.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowDiagonalBlack;

ArrowDiagonalBlack.default = ArrowDiagonalBlack;
